import type { Icon } from '../../../src/lib/types'
export const mdiPin: Icon = {
  "id": "pin",
  "name": "Pin",
  "path": "M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z",
  "as": [
    "keep"
  ],
  "tags": []
}
export default mdiPin